/*
 * spurtcommerce
 * version 4.5
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2021 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Api } from '../providers/api/api';

@Injectable()
export class CustomerService extends Api {
	private base: string;

	/*** create ad api ***/

	public createCustomer(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-customer/create', params);
	}

	public createVendorAdmin(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-admin/create', params);
	}

	public createStockiest(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/stockiest/create', params);
	}

	public sellerAdd(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/admin-vendor/add-vendor-by-vendor', params);
	}

	sellerUpdate(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.put(
			this.base + '/admin-vendor/update-vendor-by-vendor/' + params.id, params
		);
	}

	getSingleVendor(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/admin-vendor/vendor-detail/' + params.id, params);
	}

	getVendorShops(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/admin-vendor/list', { params: params });
	}

	public importCustomers(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-customer/import', params);
	}

	public updateAddress(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.put(this.base + '/vendor-customer/update-address', params);
	}

	public updateCustomer(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-customer/update/' + params.id + '/' + params.addressId, params);
	}


	public createOfflineMessage(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/create-offline-message', params);
	}

	public createTickets(params: any): Observable<any> {
		console.log("params of update ticket in service");
		console.log(params);
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/create-ticket', params);
	}


	public updateTicketsPriority(params: any): Observable<any> {
		console.log("params of update ticket in service");
		console.log(params);
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/update-ticket-priority/' + params.ticketId + '/' + params.priority, params);
	}

	public updateTicketsSummary(params: any): Observable<any> {

		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/update-ticket-summary/' + params.ticketId, params);
	}


	public assignTicket(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/assign-ticket', params);
	}


	public updateVendorAdmin(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-admin/update/' + params.id, params);
	}

	public updateStockiest(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/stockiest/update/' + params.id, params);
	}

	public assignBooking(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor/booking-request/update-booking', params);
	}


	public multiAddress(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/CustomerAddress/multi-address', {
			params: params
		});
	}


	public getOfflineResponse(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-offline-response', {
			params: params
		});
	}


	public getOrders(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-order/customer-order-list', {
			params: params
		});
	}

	public getPromotions(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + `/vendor-customer/promotions/${params.id}`);
	}

	public getCustomers(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-customer/list', { params: params });
	}

	public getRepliesOfComments(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-comment-replies', { params: params });
	}

	public getCustomersDropdown(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-customer/list-dropdown', { params: params });
	}

	public getCustomerDetails(params: any): Observable<any> {
		this.base = this.getBaseUrl();

		return this.http.get(this.base + `/vendor-customer/customer-detail/${params.customerId}`);
	}

	public getCustomerDetail(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		console.log('customer id in aoi call');
		console.log(params.id);
		return this.http.get(this.base + `/vendor-customer/detail/${params.id}`);
	}

	public getRewardPoint(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + `/user-reward-points/list-for-vendor`, {
			params: params
		});
	}

	public getVendorAdmins(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-admin/list', { params: params });
	}

	public getStockiest(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/stockiest/list', { params: params });
	}

	public getVendorAdminsList(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-admin/vendoradmin-list', { params: params });
	}



	public viewCustomer(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-customer/view/' + params);
	}

	public viewVendorAdmin(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/vendor-admin/view/' + params);
	}

	public viewStockiest(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/stockiest/view/' + params);
	}


	public deleteCustomer(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-customer/delete', params);
	}

	public deleteKeywordTag(params): Observable<any> {
		console.log("paramns");
		console.log(params);
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/delete-keyword/' + params.id, params);
	}


	public deleteStockiest(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/stockiest/delete', params);
	}

	public deleteVendorAdmin(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-admin/delete', params);
	}

	//--------------------For Newsletter Email User Import to Database----------------------------//
	public importNewsletterUsers(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/vendor-customer/import/newsletter', params);
	}

	public createKeywordTag(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/create-keyword-tag', params);
	}

	// public updateKeywordTag(params: any): Observable<any> {
	// 	this.base = this.getBaseUrl();
	// 	return this.http.post(this.base + '/customer/update-keyword-tag', params);
	// }

	public updateKeywordTag(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/update-keyword-tag/' + params.id, params);
	}


	public getKeywordTag(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-keyword-tag', params);
	}

	public getTickets(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-tickets/' + params.type, {
			params: params
		});
		//return this.http.get(this.base + '/customer/get-tickets/' + params.type, params);
	}

	public getFbLongToken(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		console.log("fb params");
		console.log(params);
		return this.http.get(this.base + '/customer/get-live-longfb-token', {
			params: params
		});
		//return this.http.get(this.base + '/customer/get-tickets/' + params.type, params);
	}


	public getFacebookComments(params): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/facebook-comments', { params: params });
	}


	public getConversation(params: any): Observable<any> {
		console.log("in converiosn api");
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-conversation', {
			params: params
		});
	}


	public getMessages(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-messages/', {
			params: params
		});
	}


	public getInstagramPosts(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-instagram-posts', {
			params: params
		});
	}

	public getPageConversation(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-page-conversation', {
			params: params
		});
	}

	public getGoogleToken(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-google-token', {
			params: params
		});
	}


	public saveGoogleToken(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/save-google-token', params);
	}

	public replyToInstaComment(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/reply-to-insta-comment', params);
	}

	public replyToComment(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/reply-to-comment', params);
	}

	public replyToMessage(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/reply-to-message', params);
	}


	// public replyToComment(params: any): Observable<any> {
	// 	this.base = this.getBaseUrl();
	// 	return this.http.post(this.base + '/customer/reply-to-comment', {
	// 		params: params
	// 	});
	// }

	public getAllTickets(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-all-tickets/' + params.type, {
			params: params
		});
	}

	public vendorAdminList(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/vendor-admin-list/' + params.type, params);
	}

	public getTicketsChats(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + '/customer/get-tickets-chats/' + params.chatId + '/' + params.type + '/' + params.ticketId, params);
	}



	// public customerWithPhoneNumber(params: any): Observable<any> {
	// 	this.base = this.getBaseUrl();
	// 	return this.http.get(this.base + '/user-post/List', {
	// 		params: params
	// 	});
	// }

	public getUserUnreadEmials(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/user-post/get-user-unread-emails', params);
	}

	public getEmailTicketsChats(params: any): Observable<any> {
		this.base = this.getBaseUrl();

		if (params.subType == 0) {
			return this.http.post(this.base + '/user-post/get-user-emails', params);
		} else {
			return this.http.post(this.base + '/user-post/get-unread-emailsconverstion', params);
		}
	}

	public connectWithAnotherUser(params: any): Observable<any> {
		this.base = this.getBaseUrl();

		return this.http.post(this.base + '/customer/connect-with-another-user-facebook', params);
	}



	/* create vendor post api*/
	public shareChatUrl(params: any): Observable<any> {
		console.log("share chat url");
		console.log(params);
		return this.http.post(this.base + '/user-post/send-customer-email', params);
	}


	public cupdateCustomerComment(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + '/customer/profile/comment/' + params.id, params);
	}



}
